/** The two parts of the Rooms list both pages share: the strip that says new rooms are held, and the filters. */
import { Icon } from "../../components/ui/Icon";
import type { RoomFilter } from "./roomWords";

export const FILTERS: ReadonlyArray<[RoomFilter, string]> = [
  ["all", "All"],
  ["published", "Published"],
  ["drafts", "Drafts"],
];

export function HeldStrip({ held, billing }: { held: "payment" | "library"; billing: string | undefined }) {
  return (
    <div className="strip warn rooms-held">
      <div className="ic">
        <Icon name="clock" />
      </div>
      <div className="sp">
        <b>{held === "payment" ? "Waiting for your payment." : "Your video storage is full."}</b>
      </div>
      {billing ? (
        <a className="btn s p" href={billing}>
          Open Billing
        </a>
      ) : null}
    </div>
  );
}
